import {externalEmails as externalEmails} from 'pages/externalEmails'

export default [
  { path: '/external-emails', name: 'externalEmails.all', component: externalEmails
    , meta:{permits:['super_admin']}},
]
